// Report It idempotency nonce (v7 §10.3). Isolated from reportItApi so the API
// client (and the submission flow that imports it) stay free of the ESM-only
// `nanoid` import — the app's Jest config does not transform node_modules ESM,
// so any importer would otherwise have to mock nanoid.
import { nanoid } from 'nanoid';

/** A fresh idempotency nonce — generated once when the report dialog opens so a
 *  resubmit of the same draft collapses onto the same report (v7 §10.3). */
export const generateClientReportNonce = (): string => `rin_${nanoid()}`;
